import type { Route } from 'vue-router';

export const baseUrl = () => process.env.internalBaseUrl.replace(/\/$/, ''); // 'https://bravado.co';

export const makeUrl = (url: string, encoded = false) => {
  const fullUrl = `${baseUrl()}${url}`;
  return (encoded && encodeURIComponent(fullUrl)) || fullUrl;
};

export const open = (url: string, ...rest: any[]) => window.open(url, ...rest);

export const redirectTo = (url: string) => {
  window.location.href = url;
};

export const buildQuery = (params: Route['params'], shouldCleanEmptyParams = false) => {
  if (!params) return '';

  const query = Object.entries(params).reduce((acc: string[], [key, param]) => {
    if (!param && shouldCleanEmptyParams) return acc;

    acc.push(`${key}=${param}`);
    return acc;
  }, []);

  return query.length ? `${query.join('&')}` : '';
};

export const isUrl = (string: string) => {
  try {
    // eslint-disable-next-line no-new
    new URL(string);
  } catch {
    return false;
  }

  return true;
};

/**
 * Extract utms from query
 * @param {*} this.$route.query
 * @returns
 */
export const getUtmParams = (routerQuery: Route['query']) => {
  return Object.entries(routerQuery).reduce((utms: Record<string, string | (string | null)[]>, [name, value]) => {
    if (name.toLowerCase().startsWith('utm_')) {
      utms[name] = value;
    }
    return utms;
  }, {});
};

export const convertQueryOrParamsToString = (
  queryOrParams: Route['query'] | Route['params'],
  paramName: string,
): string => {
  const value = queryOrParams[paramName] ?? '';

  return Array.isArray(value) ? value.join(',') : String(value);
};

export const WHITE_LIST_LPS = ['/outbound-2024', '/revrecap2024', '/flex', '/full-time', '/flex-rep'];

export const isExternalReferer = (referer: string) => {
  if (WHITE_LIST_LPS.some(lp => referer?.toLowerCase().includes(lp))) {
    return true;
  }

  const urlRegex = /https?:\/\/[^\s/$.?#].[^\s]*/g;
  const urlMatches = referer.match(urlRegex);

  if (urlMatches) {
    const externalUrl = urlMatches.some(url => /bravado\.co\/lp\//.test(url) || !/bravado\.co\//.test(url));
    if (externalUrl) {
      return true;
    }
  }

  return referer.includes('/lp/');
};
